import { BEIGE_400, BLUE_600, GRAY_700, GRAY_900 } from 'constants/styling/theme'
import { Box, Stack, Typography } from '@mui/material'

import { ADJUST_LOOKS } from '../adjust.types'
import { AdjustSlider } from '../AdjustControlPrimitives.component'
import { FC } from 'react'
import { useAdjustEditor } from '../AdjustEditor.context'
import { useTranslation } from 'react-i18next'

/** The 7 curated looks, previewed on the photo itself, with an intensity once one is picked */
export const FiltersControls: FC<{ disabled?: boolean }> = ({ disabled = false }) => {
  const { t } = useTranslation(['photo_studio_editing'])
  const { doc, apply, commit, lookThumbnails } = useAdjustEditor()

  return (
    <Stack gap="1.2rem">

      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: '0.8rem' }} role="radiogroup" aria-label={t('manual_tools.FILTERS')}>
        {ADJUST_LOOKS.map((look) => {
          const isSelected = doc.look.id === look.id
          const thumbnail = lookThumbnails[look.id]
          return (
            <Box
              key={look.id}
              component="button"
              type="button"
              role="radio"
              aria-checked={isSelected}
              disabled={disabled}
              onClick={() => apply({ type: 'setLook', id: look.id })}
              sx={{
                font: 'inherit',
                padding: 0,
                border: 0,
                background: 'none',
                display: 'flex',
                flexDirection: 'column',
                gap: '0.4rem',
                cursor: disabled ? 'not-allowed' : 'pointer',
                opacity: disabled ? 0.5 : 1,
                textAlign: 'left',
                '&:focus-visible': { outline: `2px solid ${BLUE_600}`, outlineOffset: 2 },
              }}
            >

              <Box
                sx={{
                  width: '100%',
                  aspectRatio: '3 / 2',
                  borderRadius: '0.6rem',
                  backgroundColor: BEIGE_400,
                  backgroundImage: thumbnail ? `url("${thumbnail}")` : 'none',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  boxShadow: isSelected ? `0 0 0 2px ${BLUE_600}` : 'none',
                }}
              />

              <Typography sx={{ fontSize: '1.2rem', lineHeight: 1.3, fontWeight: isSelected ? 550 : 400, color: isSelected ? GRAY_900 : GRAY_700 }}>
                {t(`adjust.filters.look.${look.id}`)}
              </Typography>

            </Box>
          )
        })}
      </Box>

      {doc.look.id !== 'original' && (
        <AdjustSlider
          label={t('adjust.filters.intensity')}
          value={doc.look.intensity}
          valueLabel={`${doc.look.intensity}%`}
          min={0}
          max={100}
          origin={0}
          disabled={disabled}
          onChange={(intensity) => apply({ type: 'setLookIntensity', intensity }, 'look:intensity')}
          onCommit={commit}
        />
      )}

    </Stack>
  )
}
